<template>
   <div class="advMain" id="page5">
     <div style="width: 1440px;margin: 0 auto;display: flex;justify-content: space-between;box-sizing: border-box;padding: 0px 20px;">
       <div class="rightBlock">
         <transition name="fdj">
           <img class="fdj" src="../../assets/images/fdj.png" />
         </transition>
         <!-- <transition name="iconImg"> -->
          <img class="zl" src="../../assets/images/zl.png" />
         <!-- </transition> -->
         <!-- <transition name="iconImg"> -->
          <img class="tp" src="../../assets/images/tp.png" />
         <!-- </transition> -->
         <!-- <transition name="iconImg"> -->
          <img class="bz" src="../../assets/images/bz.png" />
         <!-- </transition> -->
       </div>
       <div class="leftBlock">
         <h3 class="title">{{mk4.title}}</h3>
         <p class="message">
           {{mk4.content}}
         </p>
         <!-- <div class="buttonWrap"><Mybutton @clickFn="showForm">了解专利防伪</Mybutton></div> -->
         <div
           style="width: 150px;height: 50px;border-radius: 40px;background: #fff;text-align: center;line-height: 50px;margin-top: 40px;background: linear-gradient(to bottom right, #02B4E0 40%, #14E1A0 99%);color: #fff;letter-spacing: 2px;cursor: pointer;" @click="childMethod">
           {{mk4.buttonName}}</div>
       </div>
     </div>

   </div>
</template>
<script>
import {
    getIndex
  } from '@/api/api'
export default {
  name: 'codeOffic',
  components: {
    // Mybutton
  },
  props:{
    officShow: Boolean,
  },
  data () {
    return {
      mk4: {}
    }
  },
  methods:{
    setIndex() {
      getIndex().then(res=> {
          this.mk4 = res.mk4
      })
    },
    childMethod () {
    			this.$emit('fatherMethod');
    		}
    // showForm() {
    //   this.$emit('changeVisible', true)
    // }
  },
  mounted() {
    this.setIndex()
  }
}
</script>
<style scoped lang="scss">
/**放大镜动画**/
.fdj{
  position: absolute;
  left: 411px;
  top: 0;
}

.fdj-enter-active {
  animation: fdj-in-out 2s;
  animation-delay: 0.3s;
}
.fdj-leave-active {
  // animation: fdj-in-out .3s reverse;
  animation-delay: 0;
}

@keyframes fdj-in-out {
  0% {
    left: 411px;
    top: 0;
  }
  10%{
    left: 250px;
    top: 50px;
  }
  30%{
    left: 400px;
    top: 10px;
  }
  60%{
    left: 230px;
    top: 200px;
  }
  90%{
    left: 300px;
    top: 250px;
  }
  100%{
    left: 411px;
    top: 0;
  }
}


/**图标动画**/
.zl {
  position: absolute;
  left: 140px;
  top: 208px;
  animation: icon-in-out 2s .8s;
  opacity: 0;
  animation-fill-mode: forwards;
}
.tp {
 position: absolute;
 left: 0;
 bottom: 0;
 opacity: 0;
 animation: icon-in-out 2s .8s;
 animation-fill-mode: forwards;
}
.bz {
 position: absolute;
 right: 44px;
 top: 228px;
 opacity: 0;
 animation: icon-in-out 2s .8s;
 animation-fill-mode: forwards;
}

.iconImg-enter-active {
  animation: icon-in-out .5s;
  animation-delay: .8s;
}
.iconImg-leave-active {
  animation: icon-in-out .3s reverse;
  animation-delay: 0;
}
@keyframes icon-in-out {
  0%{
    opacity: 0;
    transform: scale(0.2)
  }
  100%{
    opacity: 1;
    transform: scale(1)
  }
}
  .advMain{
    // padding: 12% 100px 75px;
    padding: 130px 0 64px;
    box-sizing: border-box;
    height: 560px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    background: #F7F6FA;
    .leftBlock{
      width: 524px;
      .title{
        font-size: 40px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: normal;
        color: #1F2329;
        line-height: 56px;
      }
      .message{
        font-size: 18px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: normal;
        color: #36444D;
        line-height: 28px;
      }
      .buttonWrap{
        margin-top: 50px;
      }
    }
    .rightBlock{
      width: 480px;
      height: 362px;
      background: url('../../assets/images/bg_4.png') top left no-repeat;
      position: relative;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/components/CodeOffic.vue